import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * baseLayout服务，用于控制baseLayout的状态
 */
@Injectable({
  providedIn: 'root',
})
export class BaseLayoutService {
  // 侧边栏收起状态 在全局检测
  slidIsCollapsed: BehaviorSubject<boolean> = new BehaviorSubject(false);

  // 是否显示选题篮
  showBasket: boolean = true;
}
